import { render, staticRenderFns } from "./NewAddress.vue?vue&type=template&id=02e29be8&"
import script from "./NewAddress.vue?vue&type=script&lang=js&"
export * from "./NewAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports